import { render, staticRenderFns } from "./switchLang.vue?vue&type=template&id=8e3f6180&scoped=true"
import script from "./switchLang.vue?vue&type=script&lang=js"
export * from "./switchLang.vue?vue&type=script&lang=js"
import style0 from "./switchLang.vue?vue&type=style&index=0&id=8e3f6180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f6180",
  null
  
)

export default component.exports